import React from "react";
import PropTypes from "prop-types";
import { IconButton } from "@material-ui/core";
import { ChevronLeft, ChevronRight } from "@material-ui/icons";

// Pagination footer for card/grid views (where CustomTableFooter — a
// <TableFooter> — can't be used). Mirrors its look: "from - to of count" with
// prev/next. Hidden when everything fits on a single page.
const CardPaginator = ({ page, count, rowsPerPage, onChangePage }) => {
  if (!count || count <= rowsPerPage) return null;

  const from = rowsPerPage * page - rowsPerPage + 1;
  const to = rowsPerPage * page > count ? count : rowsPerPage * page;
  const lastPage = Math.ceil(count / rowsPerPage);

  return (
    <div className="d-flex justify-content-end align-items-center px-8 pb-4">
      <p className="m-0">
        {from} - {to} of {count}
      </p>
      <IconButton
        aria-label="Previous page"
        disabled={page <= 1}
        size="small"
        className="mx-6"
        onClick={() => onChangePage(page - 1)}
      >
        <ChevronLeft />
      </IconButton>
      <IconButton
        aria-label="Next page"
        disabled={lastPage <= page}
        size="small"
        onClick={() => onChangePage(page + 1)}
      >
        <ChevronRight />
      </IconButton>
    </div>
  );
};

CardPaginator.propTypes = {
  page: PropTypes.number,
  count: PropTypes.number,
  rowsPerPage: PropTypes.number,
  onChangePage: PropTypes.func.isRequired,
};

CardPaginator.defaultProps = {
  page: 1,
  count: 0,
  rowsPerPage: 12,
};

export default CardPaginator;
